import React from 'react'
import ScheduleCallButton from './ScheduleCallButton'

interface ScheduleCallSectionProps {
	title: string
	externalCallUrl?: string
}

const ScheduleCallSection = ({
	title,
	externalCallUrl = null,
}: ScheduleCallSectionProps) => {
	return (
		<div className="bg-gray-100 py-10 border rounded mt-8">
			<div className="container mx-auto px-8 text-center">
				{title && <h4 className="text-xl text-gray-900 mb-4">{title}</h4>}
				<ScheduleCallButton externalCallUrl={externalCallUrl} />
			</div>
		</div>
	)
}
export default ScheduleCallSection
